// extracted by mini-css-extract-plugin
export default {"form":"NewsForm_form__9BjCI","button":"NewsForm_button__3yPF+","formGroup":"NewsForm_formGroup__PxAI4","checkBoxFlex":"NewsForm_checkBoxFlex__a0Iah"};